import yup from '../../../../config/yup';

export const batchTaskValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('dataOperation'),
  function: yup.string().default('batch'),
  parameters: yup.object().shape({
    id: yup.string(),
    inputBatchGroupBy: yup
      .object()
      .shape({
        id: yup.string(),
      })
      .required('Input Batch Group By is required'),
    inputBatchSize: yup.string().required('Input Batch Size is required'),
    inputBatchFields: yup.string().required('Input Batch Fields is required'),
    batchedColumnAlias: yup.string(),
    inputTable: yup.string(),
    result: yup.string(),
  }),
});
